import { render, staticRenderFns } from "./FotoIBPAdicionar.vue?vue&type=template&id=d2aaab7c"
import script from "./FotoIBPAdicionar.vue?vue&type=script&lang=js"
export * from "./FotoIBPAdicionar.vue?vue&type=script&lang=js"
import style0 from "./FotoIBPAdicionar.vue?vue&type=style&index=0&id=d2aaab7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports